import { createStyles, makeStyles } from '@material-ui/core';

import { Sizes } from '../../../../styles/sizes';
import { colorVariables } from '../../../../styles/colorVariables';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: 750,
    },
    modalRoot: {
      width: '100%',
    },
    modalWrap: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    doneIconModal: {
      width: 48,
      height: 48,
    },
    modalTitle: {
      fontFamily: 'Sofia Pro',
      fontSize: 30,
      fontWeight: 700,
      marginTop: 20,
      maxWidth: '80%',
      textAlign: 'center',
      color: colorVariables.navy,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 24,
      },
    },
    title: {
      fontFamily: 'Sofia Pro',
      fontSize: 24,
      fontWeight: 700,
      color: colorVariables.navy,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 18,
      },
    },
    subTitle: {
      fontSize: 14,
      fontWeight: 400,
      margin: '14px 0',
      lineHeight: '24px',
      color: colorVariables.grey80,
    },
    modalDesc: {
      width: 450,
      marginBottom: 30,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: colorVariables.grey80,
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginBottom: 20,
        width: '100%',
      },
    },
    tip: {
      background: '#FEFAE7',
      fontSize: 14,
      fontWeight: 400,
      padding: '14px 26px',
      lineHeight: '24px',
      '& strong': {
        fontWeight: 700,
      }
    },
    btnBox: {
      marginTop: 30,
      display: 'flex',
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'column-reverse',
        '& button': {
          marginBottom: 20,
        },
      },
    },
  }),
);
